import React, { useRef, useState } from 'react'
import { useFormikContext } from 'formik'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { BookOptionType } from '@models/myWriting/salesAndAnalytics/BookOptionType'
import { useMyWritingAction } from '@hooks/book/myWriting/useMyWritingAction'
import { useOutside } from '@hooks/useOutside'
import { SearchBookFieldProps, WithSearchBookFieldProps } from './interface'
import { SaleAndAnalyticsQueryParams } from '../../interfaces/SaleAndAnalyticsQueryParams'

const withSearchBookField = (Component: React.FC<SearchBookFieldProps>) => {
  function WithSearchBookField({ name, ...props }: WithSearchBookFieldProps) {
    const searchRef = useRef<HTMLDivElement>(null)
    const [text, setText] = useState('')
    const searchText = useRef('')
    const myWritingClient = useMyWritingAction()
    const router = useRouter()
    const [isShowSearchLog, setIsShowSearchLog] = useState<boolean>(false)
    const { setFieldValue, submitForm } =
      useFormikContext<SaleAndAnalyticsQueryParams>()

    useOutside(searchRef, () => {
      hideSearchLog()
      setText(searchText.current)
    })

    const { data: books = [] } = useQuery(
      'books',
      () => myWritingClient.getBooksTitleAndIdByUser(''),
      {
        onSuccess: res => {
          if (router.query.bookId) {
            const book = res.find(
              item => item.bookId === Number(router.query.bookId)
            )
            const bookTitle = book?.bookTitle || ''
            setText(bookTitle)
            searchText.current = bookTitle
          }
        },
      }
    )

    function showSearchLog() {
      setIsShowSearchLog(true)
    }

    function hideSearchLog() {
      setIsShowSearchLog(false)
    }

    function handleTextChange(event: React.ChangeEvent<HTMLInputElement>) {
      setText(event.target.value)
    }

    function handleSelectBook(book: BookOptionType) {
      setFieldValue(name, book.bookId)
      setText(book.bookTitle)
      searchText.current = book.bookTitle
      submitForm()
      hideSearchLog()
    }

    function removeSearchText() {
      searchText.current = ''
      setFieldValue(name, undefined)
      setText('')
      submitForm()
    }

    const componentsProps = {
      ...props,
      text,
      isShowSearchLog,
      books: books.filter(row => row.bookTitle.includes(text)),
      inputRef: searchRef,
      showSearchLog,
      hideSearchLog,
      handleSelectBook,
      handleTextChange,
      removeSearchText,
    }
    return <Component {...componentsProps} />
  }

  return WithSearchBookField
}

export { withSearchBookField }
